export class SensorData {
    sensorName: string;
    sensorNickname: string;
    lastModified: Date;
    sensorData = {};
    alertFlag: boolean;
    triggeredAlerts: string;
};
